import { AiUsageSection } from "@/components/settings/AiUsageSection";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/settings/ai-usage")({
  component: AiUsageSection,
});
